import { FormatLanguageEnum } from "./enums/FormatLanguageEnum";

export const formatLanguageKey = (
  language: string,
  format: FormatLanguageEnum,
): string => {
  const lang = language.substring(0, 2).toLowerCase();
  switch (format) {
    case FormatLanguageEnum.TITLE_CASE:
      // e.g., 'th' -> 'Th'
      return lang.charAt(0).toUpperCase() + lang.slice(1).toLowerCase();
    case FormatLanguageEnum.UPPERCASE:
      // e.g., 'th' -> 'TH'
      return lang.toUpperCase();
    case FormatLanguageEnum.LOWERCASE:
      // e.g., 'TH' -> 'th'
      return lang.toLowerCase();
    case FormatLanguageEnum.REGIONAL_UPPERCASE:
      // e.g., 'TH' -> 'TH-TH'
      return `${lang.toUpperCase()}-${lang.toUpperCase()}`;
    case FormatLanguageEnum.REGIONAL_LOWERCASE:
      // e.g., 'th' -> 'th-th'
      return `${lang.toLowerCase()}-${lang.toLowerCase()}`;
    default:
      // e.g., 'th' -> 'th'
      return lang.substring(0, 2).toLowerCase();
  }
};
